/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getDefaultBusinessId.internal

import features.getDefaultBusinessId.models.DefaultBusiness
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class GetDefaultBusinessIdRequest : NetworkRequest() {

    suspend fun getDefaultBusinessId(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<DefaultBusiness> {
        return safeNetworkCall {
            get(
                endpoint = GetDefaultBusinessIdEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
